import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import VisitorAccessStatisticsList from './components/VisitorAccessStatisticsList';

const { Cell } = ResponsiveGrid;

const VisitorAccessStatistics = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="訪客門禁統計"
        // description="訪客列表"
        breadcrumbs={[
          {
            name: '訪客門禁',
          },
          {
            name: '訪客門禁統計',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <VisitorAccessStatisticsList />
    </Cell>
  </ResponsiveGrid>
);

export default VisitorAccessStatistics;
